import { Observable } from 'rxjs/Observable'

export const ServiceMock = {
  findModelById: () => Observable.of({})
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/services/service.mock.ts